<div class="hard-rate-layout">
  <div class="content-box">
    <p>Сongratulations! Take a minute to review your policy.</p>
    <span>Feel free to click "Edit plan" to choose a different quote, then make a call to finalize your policy</span>
    <div class="hate-box">
      <div class="details-box">
        <div class="title">
          <div class="buttons-box">
            <button class="button-outline" (click)="editQuote()">
              Edit plan
            </button>
          </div>
        </div>
        <div class="content-loop" *ngIf="quote">
          <div class="content-header">
            <p>Policy Coverage</p>
          </div>
          <div
            *ngFor="let coverage of quote.policyCoverages; let i = index"
            class="item-loop"
          >
            <span>{{ coverage.description }}</span>
            <p>
              <span *ngFor="let item of coverage.amounts; last as isLast">{{
                  item.amount | currency: 'USD':'symbol':'1.0-2' | thousands
                }}{{ !isLast ? '/' : '' }}</span>
            </p>
          </div>
          <div class="content-header">
            <p>Vehicle Coverage</p>
          </div>
          <div
            *ngFor="let coverage of quote.vehicleCoverages; let i = index"
            class="item-loop"
          >
            <span>{{ coverage.description }}</span>
            <p>
              <span *ngFor="let item of coverage.amounts; last as isLast">{{
                  item.amount | currency: 'USD':'symbol':'1.0-2' | thousands
                }}{{ !isLast ? '/' : '' }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="price-box">
<!--        <div class="header-title">-->
<!--          <svg-->
<!--            width="16"-->
<!--            height="16"-->
<!--            viewBox="0 0 16 16"-->
<!--            fill="none"-->
<!--            xmlns="http://www.w3.org/2000/svg"-->
<!--          >-->
<!--            <path-->
<!--              d="M1 5.64282H15"-->
<!--              stroke="#696863"-->
<!--              stroke-width="1.5"-->
<!--              stroke-linecap="round"-->
<!--              stroke-linejoin="round"-->
<!--            />-->
<!--            <path-->
<!--              d="M13.6 2.85718H2.4C2.0287 2.85718 1.6726 3.00392 1.41005 3.26514C1.1475 3.52635 1 3.88063 1 4.25003V12.6072C1 12.9766 1.1475 13.3309 1.41005 13.5921C1.6726 13.8533 2.0287 14 2.4 14H13.6C13.9713 14 14.3274 13.8533 14.5899 13.5921C14.8525 13.3309 15 12.9766 15 12.6072V4.25003C15 3.88063 14.8525 3.52635 14.5899 3.26514C14.3274 3.00392 13.9713 2.85718 13.6 2.85718V2.85718Z"-->
<!--              stroke="#696863"-->
<!--              stroke-width="1.5"-->
<!--              stroke-linecap="round"-->
<!--              stroke-linejoin="round"-->
<!--            />-->
<!--            <path-->
<!--              d="M4.7334 1V2.85714"-->
<!--              stroke="#696863"-->
<!--              stroke-width="1.5"-->
<!--              stroke-linecap="round"-->
<!--              stroke-linejoin="round"-->
<!--            />-->
<!--            <path-->
<!--              d="M11.2666 1V2.85714"-->
<!--              stroke="#696863"-->
<!--              stroke-width="1.5"-->
<!--              stroke-linecap="round"-->
<!--              stroke-linejoin="round"-->
<!--            />-->
<!--          </svg>-->
<!--                    <span>Begins</span>-->
<!--                    <p>-->
<!--                      {{-->
<!--                        policy.application?.policyDetails?.startDate | date: 'd MMMM YYYY'-->
<!--                      }}-->
<!--                    </p>-->
<!--        </div>-->
        <!--        <div class="payment-text">Your first month payment</div>-->
        <!--        <div class="payment-currency">-->
        <!--          <div class="amount">-->
        <!--            {{ quote.monthlyPremium | currency }}-->
        <!--          </div>-->
        <!--        </div>-->
        <div>
          {{ quote?.quotePrice | currency: 'USD':'symbol':'1.0-0' }} total over the
          course of 6 months
        </div>
        <div class="bottom-section">
          <div class="text-content">
            <span>If you’re unsure of your choice or have any questions, please contact us.</span>
          </div>
          <!--          <button class="button-outline" routerLink="/form/book-call">-->
          <!--            Book a Call-->
          <!--          </button>-->
          <button *ngIf="!!!(callBox$|async)" class="button-outline" (click)="onCall()">
            Call Now
          </button>
          <a href="tel:+14105802800" *ngIf="(callBox$|async)" class="button-gray" (click)="onCall()">
            <span>
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.1667 10.9167C13.125 10.9167 12.125 10.75 11.1917 10.4417C10.9 10.35 10.575 10.4167 10.3417 10.6417L8.50833 12.475C6.15 11.275 4.21667 9.35 3.01667 6.98333L4.85 5.14167C5.08333 4.925 5.15 4.6 5.05833 4.30833C4.75 3.375 4.58333 2.375 4.58333 1.33333C4.58333 0.875 4.20833 0.5 3.75 0.5H0.833333C0.375 0.5 0 0.875 0 1.33333C0 9.15833 6.34167 15.5 14.1667 15.5C14.625 15.5 15 15.125 15 14.6667V11.75C15 11.2917 14.625 10.9167 14.1667 10.9167ZM13.3333 8H15C15 3.85833 11.6417 0.5 7.5 0.5V2.16667C10.725 2.16667 13.3333 4.775 13.3333 8ZM10 8H11.6667C11.6667 5.7 9.8 3.83333 7.5 3.83333V5.5C8.88333 5.5 10 6.61667 10 8Z"
                  fill="#111111"
                />
              </svg>
            </span>
            410-580-2800
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
